document.addEventListener('DOMContentLoaded', () => {
  let animation_header = document.getElementById('logo-spinner__player-header');
  let elemToObserve = document.getElementById('shopify-section-header');
  let prevClassState = elemToObserve.classList.contains('shopify-section-header-sticky');
  let observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.attributeName == 'class') {
        let currentClassState = mutation.target.classList.contains('shopify-section-header-sticky');
        if (prevClassState !== currentClassState) {
          prevClassState = currentClassState;
          if (animation_header) {
            if (currentClassState) {
              animation_header.seek(12);
              animation_header.play();
            } else animation_header.stop();
          }
        }
      }
    });
  });

  observer.observe(elemToObserve, { attributes: true });
});
